import * as React from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {useState, useEffect} from 'react';
import {signDocUrl_} from 'hooks/datahook/common';

const PREFIX = "d3p3b0rs4lnh2l.cloudfront.net";

const ImageViewer = (props) => {
    const {images, open, onClose} = props;
    const [photoIndex, setPhotoIndex] = useState(0);
    const [key, setKey] = useState(false);
    const [signedImages, setSignedImages] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const isValidPrefix = (url) => {
        try {
            return url.includes(PREFIX);
        } catch {
            return false;
        }
    };

    const fetchNewImageUrl = async (url) => {
        try {
            const res = await signDocUrl_({url});
            return res.signedUrl;
        } catch (e) {
            console.error("fetchNewImageUrl error:", e);
            return "";
        }
    };

    // 处理图片 URL 签名
    useEffect(() => {
        const processImages = async () => {
            if (!open || !images || images.length === 0) {
                setSignedImages([]);
                setIsProcessing(false);
                return;
            }

            setIsProcessing(true);

            const processed = await Promise.all(
                images.map(async (url) => {
                    if (!isValidPrefix(url)) {
                        return url;
                    }

                    const newUrl = await fetchNewImageUrl(url);
                    return newUrl || url;
                })
            );
            
            setSignedImages(processed);
            setIsProcessing(false);
        };

        processImages();
    }, [open, images]);

    useEffect(() => {
        if (open) {
            setTimeout(() => setKey(key + 1));
        }
    }, [open]);

    return (
        open && !isProcessing && signedImages && signedImages.length > 0 && signedImages[photoIndex] && (
            <Lightbox
                key={key}
                mainSrc={signedImages[photoIndex]}
                nextSrc={signedImages[(photoIndex + 1) % signedImages.length]}
                prevSrc={
                    signedImages[(photoIndex + signedImages.length - 1) % signedImages.length]
                }
                onCloseRequest={onClose}
                onMovePrevRequest={() =>
                    setPhotoIndex((c) => (c + signedImages.length - 1) % signedImages.length)
                }
                onMoveNextRequest={() =>
                    setPhotoIndex((c) => (c + 1) % signedImages.length)
                }
            />
        )
    );
};

export default ImageViewer;
